import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Dict, Option, RemoteOptionWithPage, RemoteParams } from '@app/interfaces/sys/dict';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DictService {
    private moduleApi = environment.api.services.sys;
    private baseUrl = this.moduleApi + '/dicts';

    private dict: Dict[] = [];

    constructor(private http: HttpClient) {
        this.find().then(data => {
            this.dict = data;
        });
    }

    async ready(): Promise<void> {
        this.dict = await this.find();
    }

    find(): Promise<Dict[]> {
        return lastValueFrom(this.http.get<Dict[]>(`${this.baseUrl}`));
    }

    async findDictList(type: string): Promise<Option[]> {
        if (!(this.dict && this.dict.length > 0)) {
            this.dict = await this.find();
        }
        return this.dict.filter((item: Dict) => item.type === type).map((item: Dict) => {
            return {
                id: item.key,
                name: item.value,
            };
        });
    }

    findValue(type: string, key: string|number): string {
        const option = this.dict.find((item: Dict) => item.type === type && item.key === key?.toString());
        return option ? option.value : '';
    }

    async fetchRemoteOption(params: RemoteParams, requestName: string): Promise<RemoteOptionWithPage> {
        return lastValueFrom(this.http.get<RemoteOptionWithPage>(`${requestName}`, {
            params: Object.assign(params)
        }));
    }

    async create(data: Dict): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, data));
    }

}
